module.exports = __webpack_public_path__ + "static/img/why-3.0e701400.jpg";